import { gql } from "@apollo/client";

export const INCIDENT_SEARCH_QUERY = gql`
  query INCIDENT_SEARCH_QUERY(
    $perPage: Int
    $page: Int
    $json: String
    $originatorId: ID!
  ) {
    searchIncidents(
      perPage: $perPage
      page: $page
      json: $json
      originatorId: $originatorId
    ) {
      id
      incidentNumber
      classification {
        id
        name
      }
      callTime
      officerIncidentSpecifics {
        id
        primaryOfficer
        officer {
          id
          deptAttribute {
            id
            badge
          }
        }
      }
      sealed
      locked
      incidentDetail {
        id
        occurredFrom
        occurredTo
      }
      address {
        id
        name
        validAddressAlerts {
          id
          alertType {
            id
            name
            alertLevel
          }
          createdAt
          officer {
            deptAttribute {
              id
              badge
              ori {
                id
                abbreviation
              }
            }
            personalAttribute {
              id
              firstName
              lastName
            }
          }
        }
      }
      personIncidentSpecifics {
        id
        sealed
        juvenile
        yoe
        person {
          aliases {
            id
            target {
              id
              validPersonAlerts {
                id
                alertType {
                  id
                  name
                  alertLevel
                }
              }
            }
          }
          validPersonAlerts {
            alertType {
              id
              name
              alertLevel
            }
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
`;
